var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame24(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16528_1318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0571 7.91V0H7.81112V7.91C7.81097 8.02294 7.77412 8.13278 7.70613 8.22296C7.63813 8.31314 7.54267 8.37878 7.43413 8.41L4.82812 9.161L10.9361 15.4L17.0431 9.163L14.4371 8.41C14.328 8.37933 14.2319 8.31392 14.1633 8.22369C14.0947 8.13346 14.0575 8.02333 14.0571 7.91Z",
    stroke: "#003EBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.829 18.225C20.829 18.3632 20.7741 18.4957 20.6764 18.5934C20.5787 18.6911 20.4462 18.746 20.308 18.746H1.562C1.49358 18.746 1.42583 18.7325 1.36262 18.7064C1.29941 18.6802 1.24198 18.6418 1.1936 18.5934C1.14522 18.545 1.10684 18.4876 1.08066 18.4244C1.05448 18.3612 1.041 18.2934 1.041 18.225V14.58H0V20.308H21.87V14.58H20.829V18.225Z",
    fill: "#003EBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16528_1318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.87,
    height: 20.308,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame24);
export default __webpack_public_path__ + "static/media/Frame (24).d27daa8ba70d88aeb9d4fded9fae87e5.svg";
export { ForwardRef as ReactComponent };